module.exports = __webpack_public_path__ + "r-v3/img/ico_reload_blue.cbdb8373.svg";